<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare_alt.png')"
          class="mx-auto"
          contain
          max-height="150px"
        ></v-img>
      </v-col>
    </v-row>
    <v-layout row v-if="error">
      <v-flex xs12 sm6 offset-sm3>
        <v-alert @input="onDismissed" type="error" dismissible>
          {{ error.message }}
        </v-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs16 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-form @submit.prevent v-model="validForm">
              <v-text-field
                prepend-icon="mdi-account-circle"
                shaped
                rounded
                solo
                dense
                flat
                outlined
                single-line
                v-model="email"
                label="Email"
                type="email"
                :rules="[required, validEmail]"
              />

              <v-text-field
                prepend-icon="mdi-lock-question"
                shaped
                rounded
                solo
                dense
                flat
                outlined
                single-line
                v-model="password"
                label="Parola"
                type="password"
                :rules="[required, min8]"
              />

              <v-text-field
                prepend-icon="mdi-lock-question"
                shaped
                rounded
                solo
                dense
                flat
                outlined
                single-line
                v-model="confirmPassword"
                label="Confirma parola"
                type="password"
                :rules="[required, comparePasswords]"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            Aveți deja un cont?
            <router-link :to="{ name: 'Signin' }" class="ml-1">
              Accesati-l acum.
            </router-link>

            <v-spacer></v-spacer>

            <!-- <v-btn @click="onSignup" :loading="loading" class="mr-2" color="primary" :disabled="!validForm"> -->
            <v-btn @click="onSignup" :loading="loading" class="mr-2" color="primary" :disabled="true">
              Inregistrati-va
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Signup",
  data() {
    return {
      email: null,
      password: "",
      confirmPassword: "",
      validForm: true,
      required: value => !!value || 'Campul nu poate fi gol'
    };
  },
  computed: {
    comparePasswords() {
      return this.password === this.confirmPassword || "Parolele trebuie sa coincida";
    },
    min8() {
      return this.password && this.password.length >= 8 || "Parola trebuie sa contina minim 8 caractere";
    },
    validEmail() {
      /* eslint-disable no-useless-escape */
      const re = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?');
      return (this.email && re.test(this.email.toLowerCase())) || "Va rugam sa introduceti o adresa de email valida";
    },
    user() {
      return this.$store.getters.user;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push({ name: "Personal" });
      }
    }
  },
  methods: {
    onSignup() {
      /* eslint-disable no-unreachable */
      return;
      this.$store.dispatch("signUserUp", {
        email: this.email,
        password: this.password
      });
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    }
  }
};
</script>
<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
